import React from 'react';

export function Checkbox({ label, checked = false, onChange, disabled = false, indeterminate = false }) {
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? .5 : 1, fontSize: 'var(--fs-body-md)', color: 'var(--text-1)' }}>
      <span
        onClick={() => !disabled && onChange && onChange(!checked)}
        style={{
          width: 18, height: 18, borderRadius: '5px', flex: 'none',
          border: `1.5px solid ${checked || indeterminate ? 'var(--brand-primary)' : 'var(--border-strong)'}`,
          background: checked || indeterminate ? 'var(--brand-primary)' : 'var(--surface-1)',
          display: 'grid', placeItems: 'center', transition: 'background var(--duration-fast), border-color var(--duration-fast)',
        }}
      >
        {checked && <svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
        {!checked && indeterminate && <span style={{ width: 8, height: 2, background: '#fff', borderRadius: 1 }} />}
      </span>
      {label}
    </label>
  );
}
